import type { SdkServices } from "../../contexts/services/types/services";
import type { ViewSummary } from "../../managers/customView/types/ui";
import type { NavBarContent, WelcomeMessages } from "../../managers/mail";
import {
    toFavoriteViewsSummary,
    toWelcomeMessages,
} from "../../managers/mail/MailViews";
import { NAV_BAR_CONTENT_KEY } from "../../managers/mail/queries";
import { useSessionQuery, type LiveState } from "../session/useSessionQuery";

const computeNavBarContent = ({ mailManager }: SdkServices) =>
    mailManager.computeNavBarContent();

/** `refresh()` recalcule les compteurs. */
export function useNavBarContent(): LiveState<NavBarContent> {
    return useSessionQuery(NAV_BAR_CONTENT_KEY, computeNavBarContent);
}

export function useWelcomeMessages(): LiveState<WelcomeMessages> {
    return useSessionQuery(
        NAV_BAR_CONTENT_KEY,
        computeNavBarContent,
        toWelcomeMessages,
    );
}

/** Cartes des vues favorites ; `refresh()` recalcule les compteurs. */
export function useFavoriteViewsSummary(): LiveState<ViewSummary[]> {
    return useSessionQuery(
        NAV_BAR_CONTENT_KEY,
        computeNavBarContent,
        toFavoriteViewsSummary,
    );
}
